/**
 * 风控提示条(W-8)。仅 status==='DEGRADED' 渲染(NORMAL/BANNED 返回 null,同 App)。
 * 浅黄底 + 左主色边(新建构件,design 无);「去申诉」受 canAppeal 控制。
 */
import type { RiskStatusResult } from '@/api/risk';

export function RiskStatusBanner({
  risk,
  onAppeal,
}: {
  risk: RiskStatusResult | undefined;
  onAppeal: () => void;
}) {
  if (!risk || risk.status !== 'DEGRADED') return null;

  return (
    <div
      className="row between mb-6"
      style={{
        background: '#FFF9E6',
        borderLeft: '3px solid var(--color-primary)',
        borderRadius: 'var(--radius-md)',
        padding: 'var(--space-4)',
      }}
    >
      <span className="sm">您的商品排名已被调整,可申诉。</span>
      {risk.canAppeal ? (
        <button type="button" className="btn btn-secondary" onClick={onAppeal}>
          去申诉
        </button>
      ) : (
        <button type="button" className="btn btn-secondary" disabled>
          申诉处理中
        </button>
      )}
    </div>
  );
}
